import React from 'react';
import {
  Box,
  Icon,
  IconName,
  Text,
  Token,
} from '@usealloy/component-library';
import PreTagContainer from './PreTagContainer';

// Turning part of an enum into a string union
type IconOptions = `${IconName.Business | IconName.Group | IconName.Person}`;

export interface EntityHeaderInfoProps {
  name: string;
  icon: IconOptions;
  token: string;
}

/**
 * A presentational component for showing:
 * - a person or biz's name in BIG text
 * - person/biz/group icon
 * - token widget
 * @param {string} props.name - The entity's name
 * @param {string} props.icon - The IconName key to use for the entity
 * @param {string} props.token - The specific token to show (Entity/Eval/App/etc.)
 */
const EntityHeaderInfo: React.FC<EntityHeaderInfoProps> = ({
  name,
  icon,
  token,
}) => (
  <Box justifyContent="flex-start" gap={4}>
    <Text as="h1" size={6} lineHeight={6} weight={500}>{name}</Text>
    <Icon icon={IconName[icon]} size="large" />
    <PreTagContainer>
      <Token displayContent={token} />
    </PreTagContainer>
  </Box>
);

export default EntityHeaderInfo;
